export default function (element, data) {
  const searchField = element.querySelector(".search-field");
  const notFound = element.querySelector(".not-found");

  notFound.style.display = "none";

  if (searchField) {
    console.log(searchField);

    searchField.addEventListener("input", function () {
        const keyword = searchField.value;
        const options = element.querySelectorAll(".search-option");
        let found = 0;

        options.forEach(element => {
          if (!keyword || element.innerText.toLowerCase().includes(keyword.toLowerCase())) {
            element.style.display = "block";
            found++;
          } else {
            element.style.display = "none";
          }
        });

        if (found > 0) {
          notFound.style.display = "none";
        } else {
          notFound.style.display = "block";
        }
    });
  }
}
